import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/src/App";

import "@/src/index.css";

const container = document.getElementById("root");

if (!container) {
  throw new Error("#root introuvable : index.html a-t-il été modifié ?");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
